import ServiceDetailLayout from '../../components/ServiceDetailLayout';

export default function SocialMediaManagementPage() {
  return <ServiceDetailLayout slug="social-media-management" />;
}
